import { ChangeDetectorRef, Component, inject, NgZone, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AppModule } from '../../app-module';
import { AuthService } from '../../commons/services/auth.service';
import { EncryptionDecryptionService } from '../../commons/services/EncryptionDecryption.service';
import { CredentialDTO, User } from '../../commons/class/user.class';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SessionStorageService } from '../../commons/services/sessionl-storage.service';
import { TextualComponent } from 'cjf.sise.web.captcha-lib';
import { ENV_TOKEN } from '../../app-module.token';


@Component({
    selector: 'oaj-login-itx',
    templateUrl: 'login.component.html',
    styleUrls: ['login.component.css'],
    imports: [AppModule, TextualComponent],
    providers: [AuthService, EncryptionDecryptionService, SessionStorageService]
})
export class LoginComponent implements OnInit {
    loginForm!: FormGroup;
    submitted = false;
    errorMessage = '';
    TypeMessage!: string;
    loading = false;
    error = '';
    MostrarOrganos = false;
    NoActive = false;
    fieldTextType = false;
    captchaValido = false;
    captchaId = '';
    @ViewChild('captchaComponent') childCaptcha!: TextualComponent;

    private fb: FormBuilder = inject(FormBuilder);
    private router: Router = inject(Router);
    private authService: AuthService = inject(AuthService);
    protected serviceED: EncryptionDecryptionService = inject(EncryptionDecryptionService);
    private changeDetectorRef: ChangeDetectorRef = inject(ChangeDetectorRef);
    private sessionStorageService: SessionStorageService = inject(SessionStorageService);
    private zone: NgZone = inject(NgZone);
    private modalService: NgbModal = inject(NgbModal);
    readonly environment = inject(ENV_TOKEN);
    public constService: any;
    IPAddress = '';

    constructor() {
        this.constService = this.environment;
    }

    ngOnInit(): void {
        // Limpiar todas las variables de sesión al cargar el componente de login
        this.sessionStorageService.clear();
        
        // Inicializa el FormGroup esperado por el template (formGroup / formControlName)
        this.loginForm = this.fb.group({
            username: ['', [Validators.required]],
            password: ['', [Validators.required, Validators.minLength(8)]]
        });

        this.getIPAddress().then(success => {
            if (!success) {
                console.error('No se pudo obtener la dirección IP');
            }
        });

    }

    // Getter para usar en el template: f.username, f.password
    get f() {
        return this.loginForm.controls;
    }

    /**
     * Funcion para enviar el formulario de inicio de sesion, se validan los campos del formulario y se llama al servicio de autenticación para iniciar sesión del usuario, se muestra un mensaje de éxito o error dependiendo del resultado de la operación
     * @returns 
     */
    onSubmit(): void {
        this.loading = true;
        this.submitted = true;
        this.errorMessage = '';

        if (this.loginForm.invalid) {
            this.loading = false;
            this.errorMessage = 'Por favor completa usuario y contraseña correctamente.';
            return;
        }

        if (!this.captchaValido) {
            this.loading = false;
            this.errorMessage = 'Validar captcha.';
            return;
        }

        const { username, password } = this.loginForm.value;
        const Passencrypted = this.serviceED.Encryption(password);
        const IPencrypted = this.serviceED.Encryption(this.IPAddress);
        const captcha = this.serviceED.Encryption(this.captchaId);
        const request: CredentialDTO = new CredentialDTO();
        request.User = username;
        request.Password = Passencrypted;
        request.Ip = IPencrypted;
        request.idCaptcha = captcha;
        // request.Password = password;
        // request.Ip = this.IPAddress;

        this.authService.login(request).subscribe({
            next: (response: any) => {

                if (response.succeeded) {
                    this.loading = false;
                    const usuario: User = new User();
                    usuario.id = response.user;
                    usuario.userName = response.account;
                    usuario.token = response.accessToken;
                    usuario.idTypeCourt = response.itypeOrg;
                    usuario.TypeCourt = response.typeOrg;
                    usuario.isAdmin = response.bAdmin;
                    usuario.idAdmin = response.iAdmin;
                    usuario.courtAux = response.iOrg;
                    usuario.nameCourtAux = response.org;
                    usuario.active = response.active;
                    usuario.bPermisoAdmin = response.bPermisoAdmin;
                    usuario.bSuperAdmin = response.bSuperAdmin;
                    usuario.bPermisoNoFirma = response.bPermisoNoFirma;
                    usuario.idAutoEnrolamiento = response.idAutoEnrolamiento;
                    usuario.cuentaConSupervision = response.cuentaConSupervision;
                    usuario.court = 0;
                    this.sessionStorageService.setItem('currentUser', usuario);
                    if (usuario.active == 0) {
                        this.zone.run(() => {

                            this.router.navigate([`AvisoPrivacidad`]);
                            //  this.router.navigate([`ChangePassIni`]);
                        });
                    }
                    else {
                        this.MostrarOrganos = true;
                        this.zone.run(() => {
                            this.router.navigate([`SelectCourt`]);
                        });
                    }
                    this.loading = false;
                    this.changeDetectorRef.detectChanges();

                }
                else {
                    this.errorMessage = 'Por favor, valida tu usuario y contraseña';
                    this.TypeMessage = 'error';
                    this.loading = false;
                    this.captchaValido = false;
                    if (this.childCaptcha) {
                this.childCaptcha.onReload();
                }
                    this.changeDetectorRef.detectChanges();
                }
            },
            error: (error) => {
                console.error('error login:', error.message);
                this.errorMessage = `Por favor, valida tu usuario y contraseña`;
                this.TypeMessage = 'error';
                this.loading = false;
                this.captchaValido = false;
                if (this.childCaptcha) {
                this.childCaptcha.onReload();
                }
                this.changeDetectorRef.detectChanges();
            }
        });




    }

    /**
     * Funcion para manejar el evento de selección de órgano en el formulario de inicio de sesión
     * @param event 
     */

    AccederOrgSel(event: any) {
        //  console.log('Organo seleccionado en login:', event);
        if (event.logout) {
            this.MostrarOrganos = false;
            this.loginForm.reset();
            this.changeDetectorRef.detectChanges();
        }
        else {
            const currentUser: User | null = this.sessionStorageService.getItem<User>('currentUser');
            currentUser!.court = event.organoSeleccionado.courtId;
            currentUser!.nameCourt = event.organoSeleccionado.courtName;
            this.sessionStorageService.setItem('currentUser', currentUser);
            this.router.navigateByUrl('/home');
        }

        // Lógica para manejar el evento de selección de órgano
    }

    toggleFieldTextType() {
        this.fieldTextType = !this.fieldTextType;
    }

    /**
     * Funcion para enviar un correo electrónico al hacer clic en un enlace, se utiliza el esquema mailto para abrir el cliente de correo predeterminado del usuario con la dirección de correo electrónico prellenada
     */
    enviarCorreo() {
        const email = 'dggj.interconexion@oaj.gob.mx';
        window.location.href = `mailto:${email}`;
    }
    navegarAlSitio() {
        const url = 'https://www.oaj.gob.mx/interconexion';
        window.open(url, '_blank');
    }
    navegarAlSitioOpc(opcion: number) {
        switch (opcion) {
            case 1:
                {
                    const url = 'https://www.oaj.gob.mx/interconexion/assets/docs/pdf/1.%20Como%20ingresar%20a%20la%20Plataforma%20de%20Interconexi%C3%B3n%20con%20Autoridades.pdf';
                    window.open(url, '_blank');
                    break;
                }
            case 2:
                {
                    const url = 'https://www.oaj.gob.mx/interconexion/assets/docs/pdf/guiaaltalinea.pdf';
                    window.open(url, '_blank');
                    break;
                }

            default:
                break;

        }
    }

    /**
     * Funcion para abrir un modal
     * @param content 
     */
    openModal(content: TemplateRef<any>) {        
        this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', size: 'xl' }).result.then(
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            (result) => {
                // this.closeResult.set(`Closed with: ${result}`);
            },
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            (reason) => {
                // this.closeResult.set(`Dismissed ${this.getDismissReason(reason)}`);
            },
        );
    }

    /**
     * Funcion para manejar la respuesta del captcha
     * @param respuesta 
     */
    respuestaCaptcha(respuesta: boolean) {
        //console.log(respuesta);
        if (respuesta) {
            this.captchaId = this.childCaptcha.captchaId;
            this.captchaValido = true;
        }

        //this.cdr.detectChanges();
    }

    /**
     * Funcion para obtener la dirección IP del usuario, se hace una consulta a un servicio externo para obtener la dirección IP pública del usuario, se encripta la dirección IP utilizando el servicio de encriptación y se asigna a la propiedad IPAddress, se resuelve la promesa con true si se obtiene la dirección IP correctamente o con false si ocurre un error durante la consulta
     * @returns 
     */
    getIPAddress(): Promise<boolean> {
        return new Promise((resolve) => {
            fetch(this.constService.ipAddress.URL_API)
                .then(respuestaRaw => respuestaRaw.json())
                .then(respuesta => {
                    this.IPAddress = respuesta.ip;
                    resolve(true);
                }, error => {
                    console.error(JSON.parse(JSON.stringify(error)));
                    resolve(false);
                });
        });
    }

}